import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { getListings } from "../../actions/listing";
import { addToCart } from "../../actions/cart";

const AllListings = ({ getListings, listings, cart, addToCart }) => {
  // const [items, setItem] = useState([]);

  // useEffect(() => {
  //   axios
  //     .get("https://african-marketplace4.herokuapp.com/api/items")
  //     .then((res) => {
  //       console.log(res.data);
  //       setItem(res.data);
  //     })
  //     .catch((err) => console.log("Error!!", err));
  // }, []);

  useEffect(() => {
    getListings();
  }, []);

  return (
    <div className='container'>
      <h1>All Listings</h1>

      {listings.map((listing) => (
        <div key={listing.id} className='card'>
          <img
            className='imgcard'
            src={listing.photo_url}
            alt={`${listing.name} `}
          />
          <h1>{listing.name}</h1>
          <p>{listing.description}</p>

          <h2>${listing.price}</h2>

          <Link key={listing.id} to={`/listing/${listing.id}`}>
            <button className='mtn-n'>View</button>
          </Link>
          <Link to={"/cart"}>
            <button onClick={() => addToCart(listing)} className='mtn-n'>
              Add To Cart
            </button>
          </Link>
        </div>
      ))}
    </div>
  );
};

const mapStateToProps = (state) => ({
  listings: state.listing.listings,
  cart: state.cart.cart,
});

export default connect(mapStateToProps, { getListings, addToCart })(
  AllListings
);
